export default {"src":"/_next/static/media/logo-dark-text.dded37c6.svg","height":39,"width":135};